const LocationIndex = () => import('./_page/location.vue')
const PackagesIndex = () => import('./_page/packages.vue')
const ExpiryIndex = () => import('./_page/expiry.vue')
const InactiveIndex = () => import('./_page/inactive.vue')
const SubscriptionIndex = () => import('./_page/subscription.vue')
const SuccessIndex = () => import('./_page/subscribed-success.vue')
const PhoneSuccessIndex = () => import('./_page/phone-success.vue')

import { VIPSonkoGuard, CheckVIPSonkoGuard, CheckAuth } from '@/common/guard'
export default [
    {
        path: '/vip_sonko/location/update/:status',
        beforeEnter: CheckAuth,
        component: LocationIndex,
        name: 'VIPSonkoLocationUpdatePage'
    },
    {
        path: '/vip_sonko/packages',
        beforeEnter: CheckVIPSonkoGuard,
        component: PackagesIndex,
        name: 'VIPSonkoPackagesIndex'
    },
    {
        path: '/vip_sonko/expiry',
        component: ExpiryIndex,
        name: 'VIPSonkoExpiryIndex'
    },
    {
        path: '/vip_sonko/inactive',
        component: InactiveIndex,
        name: 'VIPSonkoInactiveIndex'
    },
    {
        path: '/vip_sonko/packages/subscribe/:id/:option',
        beforeEnter: CheckVIPSonkoGuard,
        component: SubscriptionIndex,
        name: 'VIPSonkoSubscriptionIndexRoute'
    },
    {
        path: '/vip_sonko/subscription/successful',
        beforeEnter: CheckVIPSonkoGuard,
        component: SuccessIndex,
        name: 'VIPSonkoSuccessIndex'
    },
    {
        path: '/vip_sonko/phone/change/successful',
        beforeEnter: CheckVIPSonkoGuard,
        component: PhoneSuccessIndex,
        name: 'VIPSonkoPhoneSuccessIndex'
    }
]